import dayjs from 'dayjs';

export interface IActivities {
  id?: string;
  code?: string;
  dueDate?: Date;
  parentActivitiesIds?: string[];
  fieldName?: string;
  projectName?: string | null;
  workGroupId?: string | null;
  purpose?: string | null;
  contribution?: number | null;
  informEmails?: string | null;
  tags?: string | null;
  planTags?: string | null;
  IsDeleted?: boolean;
  dataConfirmCompleteHalfMonth?: any;
  dataConfirmCompleteMonth?: any;
  dataConfirmCompleteQuarter?: any;
  dataConfirmComplete?: any;
}

export const defaultValue: Readonly<IActivities> = {
  IsDeleted: false,
};
